import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 101,
	height: 32,
	viewBox: "0 0 101 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 15C9.94772 15 9.5 15.4477 9.5 16C9.5 16.5523 9.94772 17 10.5 17V15ZM90.5 16L80.5 10.2265V21.7735L90.5 16ZM10.5 17H81.5V15H10.5V17Z",
		fill: "#C8C8C8"
	})
});
export default SvgArrow;
